var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTlh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 569.2 201.7",
    style: {
      enableBackground: "new 0 0 569.2 201.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3A82C4;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "266.7,86.3 282.8,95.3 185.1,95.3 204.4,58.9 151.8,58.9 137.4,86 153.6,95.3 56,95.3 75.3,58.9  0,58.9 31.2,0 312.4,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "523.3,86.6 539.3,95.3 313.2,95.3 363.7,0 440.5,0 405.3,66.6 457.1,66.6 492.4,0 569.2,0  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "127.1,106.4 76.6,201.7 0,201.7 50.5,106.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "513.2,106.4 462.7,201.7 385.9,201.7 420.4,136.5 368.6,136.5 334.1,201.7 129.1,201.7 179.6,106.4  256.4,106.4 237.1,142.8 288.5,142.8 307.8,106.4  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlh);
export default __webpack_public_path__ + "static/media/TLH.1cd47d38f70d7d40b32e413198e864f9.svg";
export { ForwardRef as ReactComponent };